import Typography, {
  TypographyTag,
  TypographyVariant,
} from '~/components/Typography'
import { Product } from '~/types'
import styles from './ProductDashboardTitle.module.scss'

export interface ProductDashboardTitleProps {
  product: Product
}

export const ProductDashboardTitle = ({
  product,
}: ProductDashboardTitleProps) => {
  const { catNo, mpn } = product || {}

  return (
    <div className={styles.root}>
      <Typography
        className={styles.title}
        tag={TypographyTag.h1}
        variant={TypographyVariant.BodyXLargeSemibold}>
        {product?.title}
      </Typography>
      {(catNo || mpn) && (
        <Typography
          variant={TypographyVariant.BodySmall}
          tag={TypographyTag.div}
          className={styles.meta}>
          <div className={styles.metaList}>
            {catNo && (
              <div className={styles.metaItem}>
                Cat. No: {catNo}
                {mpn && ','}
              </div>
            )}
            {mpn && <div className={styles.metaItem}>MPN: {mpn}</div>}
          </div>
        </Typography>
      )}
    </div>
  )
}
